export default "__VITE_ASSET__CAHgS8wu__"